var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalizar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 2.47588C11.9146 2.84686 11.7277 3.18657 11.4597 3.45687L5.79289 9.12135C5.23145 9.68584 4.46761 10.0022 3.67148 9.99987H2.99994C2.44765 9.99987 1.99987 9.55209 1.99987 8.99981V8.32827C1.99758 7.53213 2.31416 6.76855 2.8789 6.20736L8.54288 0.542877C8.81114 0.274617 9.14907 0.0867078 9.51828 0H2.50003C1.12008 0.00177992 0.00177992 1.11983 0 2.50003V9.49997C0.00177992 10.8799 1.11983 11.9982 2.50003 12H8V9.49997C8 8.67154 8.67154 8 9.49997 8H12V2.47613L11.9997 2.47588Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizar);
export default __webpack_public_path__ + "static/media/personalizar.14c2742fda13867ddb9139806175029b.svg";
export { ForwardRef as ReactComponent };